import type { NavigateFunction } from 'react-router-dom';
import { authService } from '../services/api';
import { hasAcceptedCurrentLegal, syncLegalAcceptanceFromProfile } from './acceptance';

/**
 * Shared post-sign-in routing for every login path (password + Outris SSO).
 *
 * The server-recorded acceptance (`users.legal_version` / `legal_accepted_at`,
 * served by `/auth/me`) is the consent gate. This syncs it into the local
 * record, then sends the user to `targetPath` when the current
 * LEGAL_POLICY_VERSION is accepted, or to `/legal/accept` (which returns to
 * `targetPath` afterwards) when it is not. A failed `/auth/me` falls back to
 * whatever the local record says; RequireAuth re-checks on the next route.
 */
export async function routeAfterSignIn(navigate: NavigateFunction, targetPath: string): Promise<void> {
    try {
        const me: { legal_version?: string | null; legal_accepted_at?: string | null } = await authService.getMe();
        syncLegalAcceptanceFromProfile(me?.legal_version, me?.legal_accepted_at);
    } catch {
        /* fall through to the local record */
    }
    if (hasAcceptedCurrentLegal()) {
        navigate(targetPath, { replace: true });
        return;
    }
    navigate('/legal/accept', {
        replace: true,
        state: { from: { pathname: targetPath } },
    });
}
